export default __webpack_public_path__ + "static/media/p3.7d601311.png";